import * as React from "react";

/**
 *
 * This React Hook can be useful in a SSR environment to wait until be in a browser to execution some functions.
 * Indeed, in a SSR application, when the component with the `useIsClient` hook is mounted in the browser, its state changes and causes a re-render.
 * It is what we want here, but, if you want a boolean, without extra render see `useSSR()`
 *
 * @example
 * import { useIsClient } from '@griddo/core'
 *
 * export default function Component() {
 *   const isClient = useIsClient()
 *
 *   return <div>{isClient ? 'Client' : 'server'}</div>
 * }
 *
 *
 * @see
 * https://usehooks-ts.com for more hooks
 *
 */
function useIsClient() {
	const [isClient, setClient] = React.useState(false);

	React.useEffect(() => {
		setClient(true);
	}, []);

	return isClient;
}

export { useIsClient };
